export default {
  GENERAL_HEADERS: [
    { text: 'Day', width: '15' },
    { text: 'Incl. in price', width: '15' },
    { text: '', width: '20' },
    { text: 'Hotel & room', width: '80' },
    { text: 'Class', width: '20' },
    { text: 'SRS', width: '20' },
    { text: 'Comm.', width: '20' },
    { text: 'CR', width: '20' },
    { text: 'Sup. gross price', width: '20' },
    { text: 'Price', width: '20' },
    { text: 'min. cur', width: '20' },
    { text: 'max. cur', width: '20' },
    { text: 'Age disc.', width: '20' },
    { text: 'Supp.', width: '20' },
    { text: '', width: '10' },
  ],
  PACKAGE_HEADERS: [
    { text: '', width: '15' },
    { text: '', width: '15' },
    { text: '', width: '20' },
    { text: 'Package', width: '80' },
    { text: '', width: '20' },
    { text: 'SRS', width: '20' },
    { text: 'Comm.', width: '20' },
    { text: 'CR', width: '20' },
    { text: 'Sup. gross price', width: '20' },
    { text: 'Price', width: '20' },
    { text: 'min. cur', width: '20' },
    { text: 'max. cur', width: '20' },
    { text: 'Age disc.', width: '20' },
    { text: 'Supp.', width: '20' },
    { text: '', width: '10' },
  ],
};



// WEBPACK FOOTER //
// ./src/variables/itineraryPrices/itineraryPricesTableHeader.js